import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { EnhancedAutocomplete, FullRow } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { HintIcon } from '../HintIcon/HintIcon';
import styles from './ClientContactPicker.module.scss';
import { findContactOption, toContactOptions } from './ClientContactPicker.utils';
export const GetClientContactPickerTID = (parentTestId)=>getTestIds(parentTestId);
export const ClientContactPicker = (param)=>{
    let { contacts, value, onChange, onCreateContact, disabled, isLoading, placeholder, label, info, error, testId } = param;
    const { t: clientPickerTexts } = useLocaleKeys('components.clientPicker');
    const { ClientContactPickerTestIds } = useMemo(()=>GetClientContactPickerTID(testId), [
        testId
    ]);
    const options = useMemo(()=>toContactOptions(contacts), [
        contacts
    ]);
    const contactsById = useMemo(()=>new Map(contacts.map((contact)=>[
                contact.id(),
                contact
            ])), [
        contacts
    ]);
    const selectedOption = findContactOption(options, value);
    const emptySearchText = contacts.length === 0 ? clientPickerTexts.noContactsEmptyState() : clientPickerTexts.noMatchesEmptyState();
    const autocomplete = /*#__PURE__*/ _jsx(EnhancedAutocomplete, {
        bi: {
            name: 'client_contact_picker'
        },
        testId: ClientContactPickerTestIds.Autocomplete(),
        className: styles.field,
        size: "medium",
        options: options,
        keyField: "id",
        labelField: "label",
        disabled: disabled,
        isLoading: isLoading,
        textFieldProps: {
            bi: {
                name: 'client_contact_picker'
            },
            label,
            placeholder,
            alwaysShrinkLabel: true
        },
        selectedOption: selectedOption,
        applyOptionChange: (option)=>{
            var _contactsById_get;
            return onChange(option ? (_contactsById_get = contactsById.get(option.id)) !== null && _contactsById_get !== void 0 ? _contactsById_get : null : null);
        },
        newItemOption: [
            {
                text: clientPickerTexts.createNew(),
                onClick: async ()=>onCreateContact()
            }
        ],
        emptySearchText: emptySearchText,
        error: error != null,
        helperText: error
    });
    if (info == null) {
        return autocomplete;
    }
    return /*#__PURE__*/ _jsxs(FullRow, {
        gap: 8,
        alignItems: "center",
        children: [
            autocomplete,
            /*#__PURE__*/ _jsx(HintIcon, {
                info: info,
                testId: ClientContactPickerTestIds.Info()
            })
        ]
    });
};
